/** @format */

import { Col, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import CustomCard from '../Antd/Card';
import CustomImage from '../Antd/Image';
import { Service } from './service';

import "./styles.scss"

export default function BannerPromotionsV2(props) {
	const [isLoading, setLoading] = useState(true);
	const [banners, setBanners] = useState([]);
	const [module, setModule] = useState({});
	const numColWeb = props.numColWeb;
	const numColMobile = props.numColMobile;

	useEffect(() => {
		Promise.all([
			new Service().getTemplate({ template: props.template, location: props.location }),
			new Service().getModuleByTemplate({ template: props.template, query: props.location }),
		])
			.then(([templateResponse, moduleResponse]) => {
				console.log('templateresponse',templateResponse,'moduleResponse',moduleResponse)
				if (templateResponse.data.length > 0) {
					setBanners([...templateResponse.data]);
					setModule(moduleResponse.data);
					setLoading(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [props.template, props.location]);

	if (isLoading) {
		return Fragment;
	}

	return (
		<>
			<h1 className="ph-home-title">{module?.title}</h1>
			<Row className='ph-row-banner-container'>
				{banners?.map((item, i) => {
					return (
						<>
							<Col xs={numColMobile} sm={numColWeb} md={numColWeb} lg={numColWeb} xl={numColWeb} key={i} className='ph-col-banner-container'>
								<a href={`${item.link}`} rel="noopener noreferrer">
									<CustomCard className="ph-banner-container">
										<CustomImage className={'ph-banner-image'} src={item.image} />
									</CustomCard>
								</a>
							</Col>
						</>
					);
				})}
			</Row>
		</>
	);
}
